<script>
  import Icon from "./Icon.svelte";
</script>

<Icon>
  <title>Icon: ellipse</title>
  <path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M22,2 L2,2 L2,22 L22,22 L22,2 Z" />
</Icon>
